import { render, staticRenderFns } from "./memberCard.vue?vue&type=template&id=408b66b4"
import script from "./memberCard.vue?vue&type=script&lang=ts"
export * from "./memberCard.vue?vue&type=script&lang=ts"
import style0 from "./memberCard.vue?vue&type=style&index=0&id=408b66b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports